/**
 * Renew the staff (Hub) session: one in-flight call shared by every caller.
 *
 * A screen that fires six parallel requests must not fire six refreshes: they
 * would each redeem the rotating refresh token and the losers would be classed
 * as replay. Its own module so the customer portal bundle — which uses it only
 * for a staff "View as customer" preview — does not pull in the staff client.
 */
let refreshPromise: Promise<boolean> | null = null;

export async function tryRefresh(): Promise<boolean> {
  refreshPromise ??= fetch("/api/auth/refresh", { method: "POST", credentials: "include" })
    .then((r) => r.ok)
    .catch(() => false)
    .finally(() => {
      refreshPromise = null;
    });
  return refreshPromise;
}
